export default "__VITE_ASSET__y$36HZ0g__"